<template>
  <div class="animated fadeIn">
    <filters :scope="filtersScope">
    </filters>
    <div class="container__table excel" style="overflow:hidden; width:100%">
      <div id="swipe" v-hammer:pan="onSwipe" style="display:flex;flex-wrap: nowrap; width: 100%;" :style="{ 'transform': 'translate3d(' + x + 'px, 0px, 0px)'}">
        <div class="statistic-wrap">
          <div class="card statistic-table" >
            <div>
              <div class="card-header">
                {{ title }}
              </div>
              <div class="card-block">
                <table class="table">
                  <thead>
                    <tr>
                      <th :style="{background: col.color, width: col.width}" style="white-space: nowrap;" v-for="col in headColumns">{{col.label}}</th>
                    </tr>
                  </thead>

                  <tbody>
                  <template v-for="data in rows">
                    <template v-for="(countryData, indexCountry) in data">
                      <tr @click="countryData.visible = !countryData.visible">
                       <td style="background-color: #e0e0e0; cursor:pointer;">{{findCountry(indexCountry)}}</td>
                        <td style="white-space: nowrap;" v-for="row in countryData.total" :style="{background: linerGradient(row.approved, row.total)}">
                          <span style="display: inline-block; width: 50px;">{{row.total}}</span>
                          <span style="display: inline-block; width: 50px;">{{row.total && row.approved > 0 ? ((row.approved / row.total) * 100).toFixed(1) : 0}}%</span>
                          <span style="display: inline-block; width: 50px; color: red;">{{ row.total && row.spam > 0 ? ((row.spam / row.total) * 100).toFixed(1) : 0}}%</span>
                        </td>
                      </tr>
                      <template v-for="dataOffer in countryData.offers" v-if="countryData.visible">
                        <tr v-for="(rowData, index) in dataOffer">
                          <td>{{findOffer(index)}}</td>
                          <td v-for="row in rowData">
                            <span style="display: inline-block; width: 50px;" class="">{{row.total}}</span>
                            <span style="display: inline-block; width: 50px;" class="">{{row.total > 0 ? ((row.approved / row.total) * 100).toFixed(1) : 0}}%</span>
                            <span style="display: inline-block; width: 50px; color: red;" class="">{{ row.total > 0 ? ((row.spam / row.total) * 100).toFixed(1) : 0}}%</span>
                          </td>
                        </tr>
                      </template>
                    </template>
                  </template>
                  </tbody>

                  <tfoot>
                  <tr>
                    <th style="background-color: #e0e0e0;">Итого:</th>
                    <th style="background-color: #90caf9;" v-for="row in this.footColumns">
                      <span style="display: inline-block; width: 50px;">{{row.total}}</span>
                      <span style="display: inline-block; width: 50px;">{{row.total > 0 ? ((row.approved / row.total) * 100).toFixed(1) : 0}}%</span>
                      <span style="display: inline-block; width: 50px; color: red;">{{ row.total && row.spam > 0 ? ((row.spam / row.total) * 100).toFixed(1) : 0}}%</span>
                    </th>
                  </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Filters from '../../../components/Filters'
import StatisticTable from '../../../components/StatisticTable'
import API from '../../../api/API'
import {map, uniqBy, find, sortBy, orderBy} from 'lodash'
import Helper from '../../../api/Helper'
import Storage from '../../../api/Storage'
import moment from 'moment'

export default {
  name: 'ArrivalNewLeads',
  components: {StatisticTable, Filters},
  data () {
    return {
      contentVisible: false,
      title: 'Поступление новых лидов',
      filtersScope: {
        ParsePeriod: true,
        dateFilter: true,
        byWmFilterAll: true,
        offerFilter: true
      },
      footColumns: [],
      headColumns: [],
      rows: [],
      x: 0,
      monthIndex: [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь'
      ],
      isParse: 'day'
    }
  },
  mounted () {
    this.$root.$on('handleChangeParse', (isParsePeriod) => {
      this.isParse = isParsePeriod
      this.calculateRows()
    })
    this.calculateRows()
    this.$root.$on('filters_load_new_data', () => {
      this.calculateRows()
    })
  },
  methods: {
    getWeekDaysByWeekNumber (week) {
      // eslint-disable-next-line one-var
      let date = moment().isoWeek(week || 1).startOf('week'), weeklength = 7, result = [], month = ''
      while (weeklength--) {
        result.push(date.format('DD'))
        month = date.format('MM')
        date.add(1, 'day')
      }
      return `Неделя с ${result[0]} - ${result[6]} ${this.monthIndex[month - 1]}`
    },
    linerGradient (approved, total) {
      let count = total && approved > 0 ? ((approved / total) * 100).toFixed(1) : 0
      return `linear-gradient(to right, #90caf9 ${count}%, white 0%)`
    },
    findCountry (id) {
      let country = find(Storage.countries, {id: parseInt(id)})
      return country.name
    },
    findOffer (id) {
      let offer = Helper.getOfferTitle(Storage.offers, id)
      return offer
    },
    onSwipe (e) {
      const offset = document.getElementById('swipe').offsetWidth
      const scroll = document.getElementById('swipe').scrollWidth
      const width = scroll - offset
      if (width > 0) {
        if (e.deltaX >= 0) {
          this.x += e.distance / 10
        } else {
          this.x -= e.distance / 10
        }
        if (this.x > 0) {
          this.x = 0
        }
        if (Math.abs(this.x) > width) {
          this.x = -width
        }
      }
    },
    dateParse (data, parse) {
      let arr = []
      map(data, arrOffer => {
        map(arrOffer, arrItems => {
          map(arrItems, item => {
            if (parse === 'day') {
              arr.push(item.date)
            }
            if (parse === 'week') {
              arr.push(item.week)
            }
            if (parse === 'month') {
              arr.push(item.month)
            }
          })
        })
      })
      const filterArr = arr.filter((item, index) => { return arr.indexOf(item) === index })
      return filterArr
    },
    calculateRows () {
      this.rows = []
      this.footColumns = []
      this.headColumns = [{label: this.$root.$t('statistic.country'), field: 'country', color: '#e0e0e0', width: '200px'}]
      API.getArrivalNewLeads(this.isParse).then(response => {
        let data = response.body
        let arrDateHead = this.dateParse(data, this.isParse)
        const dateHead = orderBy(arrDateHead, [], ['desc'])
        if (this.isParse === 'day') {
          let dateDay = dateHead
          dateDay.forEach(item => {
            this.headColumns.push({ label: item, color: '#90caf9' })
          })
          map(data, (offerCountry, indexCountry) => {
            let sortForOffers = []
            let totalCountryOffers = []
            map(offerCountry, arr => {
              for (let i = 0; i < dateHead.length; i++) {
                arr.push({
                  date: dateHead[i],
                  total: 0,
                  spam: 0,
                  approved: 0
                })
              }
            })
            map(offerCountry, (arr, indexOffer) => {
              let unicByOffer = []
              unicByOffer.push(uniqBy(arr, 'date'))
              let sortByOffer = []
              map(unicByOffer, (arr) => {
                sortByOffer.push(orderBy(arr, 'date', 'desc'))
              })
              sortForOffers.push({[indexOffer]: sortByOffer.flat()})
            })
            let allItemsOffers = []
            map(sortForOffers, arr => {
              map(arr, items => {
                map(items, item => {
                  allItemsOffers.push(item)
                })
              })
            })
            for (let i = 0; i < dateDay.length; i++) {
              let row = []
              for (let j = 0; j < allItemsOffers.length; j++) {
                if (dateDay[i] === allItemsOffers[j].date) {
                  row.push(allItemsOffers[j])
                }
              }
              totalCountryOffers.push({
                date: dateDay[i],
                total: row.map(x => x.total).reduce((a, b) => a + b),
                spam: row.map(x => x.spam).reduce((a, b) => a + b),
                approved: row.map(x => x.approved).reduce((a, b) => a + b)
              })
            }
            this.rows.push({
              [indexCountry]: {
                total: totalCountryOffers,
                offers: sortForOffers,
                visible: false
              }
            })
          })
          let allItemsTotal = []
          this.rows.forEach(arr => {
            map(arr, item => {
              map(item.total, item => {
                allItemsTotal.push(item)
              })
            })
          })
          // Подсчет общего футера таблиц
          for (let i = 0; i < dateDay.length; i++) {
            let row = []
            for (let j = 0; j < allItemsTotal.length; j++) {
              if (dateDay[i] === allItemsTotal[j].date) {
                row.push(allItemsTotal[j])
              }
            }
            this.footColumns.push({
              day: dateDay[i],
              total: row.map(x => x.total).reduce((a, b) => a + b),
              spam: row.map(x => x.spam).reduce((a, b) => a + b),
              approved: row.map(x => x.approved).reduce((a, b) => a + b)
            })
          }
        }
        if (this.isParse === 'week') {
          dateHead.forEach(item => {
            this.headColumns.push({ label: this.getWeekDaysByWeekNumber(item), color: '#90caf9' })
          })
          map(data, (offerCountry, indexCountry) => {
            let allItems = []
            let idOffers = []
            map(offerCountry, offerItems => {
              offerItems.forEach(item => {
                allItems.push(item)
                idOffers.push(item.offer_id)
              })
            })
            let idOffersFilter = idOffers.filter((item, index) => { return idOffers.indexOf(item) === index })
            // Сортировкап по offer_id
            let sortForOffers = []
            for (let i = 0; i < idOffersFilter.length; i++) {
              let row = []
              for (let j = 0; j < allItems.length; j++) {
                if (idOffersFilter[i] === allItems[j].offer_id) {
                  row.push(allItems[j])
                }
              }
              let offer = ''
              let week = []
              // Посчитанные офферы
              for (let i = 0; i < dateHead.length; i++) {
                let total = 0
                let spam = 0
                let approved = 0
                for (let j = 0; j < row.length; j++) {
                  if (dateHead[i] === row[j].week) {
                    offer = row[j].offer_id
                    total += row[j].total
                    spam += row[j].spam
                    approved += row[j].approved
                  }
                }
                week.push({
                  week: dateHead[i],
                  total: total,
                  spam: spam,
                  approved: approved,
                  offer_id: offer
                })
              }
              sortForOffers.push({
                [offer]: week
              })
            }
            // Сортировка для тотал страны
            let sortForTotal = []
            for (let i = 0; i < dateHead.length; i++) {
              let row = []
              for (let j = 0; j < allItems.length; j++) {
                if (dateHead[i] === allItems[j].week) {
                  row.push(allItems[j])
                }
              }
              // Посчитанные офферы тотал по стране
              sortForTotal.push({
                week: dateHead[i],
                total: row.map(x => x.total).reduce((a, b) => a + b),
                spam: row.map(x => x.spam).reduce((a, b) => a + b),
                approved: row.map(x => x.approved).reduce((a, b) => a + b)
              })
            }
            this.rows.push({
              [indexCountry]: {
                total: sortForTotal,
                offers: sortForOffers,
                visible: false
              }
            })
          })
          let allItemsTotal = []
          this.rows.forEach(arr => {
            map(arr, items => {
              map(items.total, item => {
                allItemsTotal.push(item)
              })
            })
          })
          // Подсчет общего футера таблиц
          for (let i = 0; i < dateHead.length; i++) {
            let row = []
            for (let j = 0; j < allItemsTotal.length; j++) {
              if (dateHead[i] === allItemsTotal[j].week) {
                row.push(allItemsTotal[j])
              }
            }
            this.footColumns.push({
              week: dateHead[i],
              total: row.map(x => x.total).reduce((a, b) => a + b),
              spam: row.map(x => x.spam).reduce((a, b) => a + b),
              approved: row.map(x => x.approved).reduce((a, b) => a + b)
            })
          }
        }
        if (this.isParse === 'month') {
          dateHead.forEach(item => {
            this.headColumns.push({ label: this.monthIndex[item - 1], color: '#90caf9' })
          })
          map(data, (offerCountry, indexCountry) => {
            let allItems = []
            let idOffers = []
            map(offerCountry, offerItems => {
              offerItems.forEach(item => {
                allItems.push(item)
                idOffers.push(item.offer_id)
              })
            })
            let idOffersFilter = idOffers.filter((item, index) => { return idOffers.indexOf(item) === index })
            // Сортировкап по offer_id
            let sortForOffers = []
            for (let i = 0; i < idOffersFilter.length; i++) {
              let row = []
              for (let j = 0; j < allItems.length; j++) {
                if (idOffersFilter[i] === allItems[j].offer_id) {
                  row.push(allItems[j])
                }
              }
              let offer = ''
              let month = []
              // Посчитанные офферы
              for (let i = 0; i < dateHead.length; i++) {
                let total = 0
                let spam = 0
                let approved = 0
                for (let j = 0; j < row.length; j++) {
                  if (dateHead[i] === row[j].month) {
                    offer = row[j].offer_id
                    total += row[j].total
                    spam += row[j].spam
                    approved += row[j].approved
                  }
                }
                month.push({
                  month: dateHead[i],
                  total: total,
                  spam: spam,
                  approved: approved,
                  offer_id: offer
                })
              }
              sortForOffers.push({
                [offer]: month
              })
            }
            // Сортировка для тотал страны
            let sortForTotal = []
            for (let i = 0; i < dateHead.length; i++) {
              let row = []
              for (let j = 0; j < allItems.length; j++) {
                if (dateHead[i] === allItems[j].month) {
                  row.push(allItems[j])
                }
              }
              // Посчитанные офферы тотал по стране
              sortForTotal.push({
                month: dateHead[i],
                total: row.map(x => x.total).reduce((a, b) => a + b),
                spam: row.map(x => x.spam).reduce((a, b) => a + b),
                approved: row.map(x => x.approved).reduce((a, b) => a + b)
              })
            }
            this.rows.push({
              [indexCountry]: {
                total: sortForTotal,
                offers: sortForOffers,
                visible: false
              }
            })
          })
          let allItemsTotal = []
          this.rows.forEach(arr => {
            map(arr, items => {
              map(items.total, item => {
                allItemsTotal.push(item)
              })
            })
          })
          // Подсчет общего футера таблиц
          for (let i = 0; i < dateHead.length; i++) {
            let row = []
            for (let j = 0; j < allItemsTotal.length; j++) {
              if (dateHead[i] === allItemsTotal[j].month) {
                row.push(allItemsTotal[j])
              }
            }
            this.footColumns.push({
              week: dateHead[i],
              total: row.map(x => x.total).reduce((a, b) => a + b),
              spam: row.map(x => x.spam).reduce((a, b) => a + b),
              approved: row.map(x => x.approved).reduce((a, b) => a + b)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// ArrivalNewLeads.vue?7aacdd41